import { GLTexture } from '../../texture.js';
import * as glMatrix from '../../../../node_modules/gl-matrix/esm';

export class Stroke {
    _gl: any;
    _width: number;
    _height: number;
    _points: glMatrix.vec2[];
    _currentPoint: number;
    _mask: GLTexture | null;
    _pixels: Uint8Array | null;
    _program: string | null;
    _accumulate: boolean;

    constructor(gl, width, height) {
        var self = this;
        self._gl = gl;
        self._width = width;
        self._height = height;
        self._points = [];
        self._currentPoint = 0;
        self._mask = null;
        self._pixels = null;
        self._program = null;
        self._accumulate = true;
    }

    get accumulate() {
        return this._accumulate;
    }

    bind() {
        var self = this;
        if (!self._mask) {
            self._mask = GLTexture.createTexture2d(self._gl, false);
            self._mask.bind();
            self._gl.texImage2D(self._gl.TEXTURE_2D, 0, self._gl.RGBA, self._width, self._height, 0, self._gl.RGBA, self._gl.UNSIGNED_BYTE, self._pixels);
            self._mask.unbind();
        }
        self._mask.bind();
    }

    unbind() {
        if (this._mask) {
            this._mask.unbind();
        }
    }

    setUniforms(program) {

    }

    destroy() {
        var self = this;
        if (self._mask) {
            self._mask.bind();
            var framebuffer = self._gl.createFramebuffer();
            self._gl.bindFramebuffer(self._gl.FRAMEBUFFER, framebuffer);
            self._gl.framebufferTexture2D(self._gl.FRAMEBUFFER, self._gl.COLOR_ATTACHMENT0, self._gl.TEXTURE_2D, self._mask._texture, 0);
            self._pixels = new Uint8Array(self._width * self._height * 4);
            self._gl.readPixels(0, 0, self._width, self._height, self._gl.RGBA, self._gl.UNSIGNED_BYTE, self._pixels);
            self._gl.bindFramebuffer(self._gl.FRAMEBUFFER, null);
            self._gl.deleteFramebuffer(framebuffer);
            self._gl.deleteTexture(self._mask._texture);
            self._mask = null;
            self._points = [];
            self._currentPoint = 0;
        }
    }

    store() {
        var self = this;
        if (self._mask) {
            self._mask.bind();
            self._gl.copyTexImage2D(self._gl.TEXTURE_2D, 0, self._gl.RGBA, 0, 0, self._width, self._height, 0);
            self._mask.unbind();
        }
    }

    addPoint(point, size) {
        var self = this;
        if (self._points.length > 0) {
            var direction = glMatrix.vec2.create();
            var previous = self._points[self._points.length - 1];
            glMatrix.vec2.subtract(direction, point, previous);
            if (glMatrix.vec2.length(direction) > size / 2) {
                glMatrix.vec2.normalize(direction, direction);
                var newPoint = glMatrix.vec2.create();
                newPoint[0] = previous[0] + direction[0] * size / 2.5;
                newPoint[1] = previous[1] + direction[1] * size / 2.5;
                self._points.push(newPoint);
                return true;
            }
        } else {
            self._points.push(point);
        }

        return false;
    }

    empty() {
        return this._points.length === 0;
    }

    next() {
        this._currentPoint += 1;
    }

    reset() {
        var self = this;
        self._currentPoint = 0;
        if (self._mask) {
            self._mask.destroy();
            self._mask = null;
            self._pixels = null;
        }
    }

    get hasPoint() {
        var self = this;
        return self._currentPoint < self._points.length;
    }

    get point() {
        var self = this;
        return self._points[self._currentPoint];
    }

    get program() {
        return this._program;
    }

}